var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum2Gray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2285 22.5V21.225C15.2435 18.525 17.0285 16.44 17.0285 14.73C17.0285 13.605 16.4285 12.93 15.3635 12.93C14.5535 12.93 13.8935 13.455 13.3235 14.07L12.1235 12.87C13.1435 11.775 14.1335 11.19 15.6485 11.19C17.7485 11.19 19.1435 12.54 19.1435 14.61C19.1435 16.62 17.4785 18.78 15.4535 20.76C16.0085 20.7 16.7435 20.64 17.2685 20.64H19.6685V22.5H12.2285Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum2Gray);
export default __webpack_public_path__ + "static/media/icon_circleNum_2_gray.f5de2a9b9fd18bd99f89088ca4c5a1d1.svg";
export { ForwardRef as ReactComponent };